import { useState } from 'react';
import {
  DAILY_USAGE_DATA,
  DEFAULT_OVERVIEW_TIMEFRAME,
  JOB_CREATION_DATA,
  MONTHLY_USAGE_DATA,
  YEARLY_USAGE_DATA,
} from '../constants';
import type { IJobCreationPoint, IUsageChartPoint, OverviewTimeframe } from '../interfaces';

export interface IUseOverviewTab {
  timeframe: OverviewTimeframe;
  setTimeframe: (timeframe: OverviewTimeframe) => void;
  chartData: IUsageChartPoint[];
  jobCreationData: IJobCreationPoint[];
}

export const useOverviewTab = (): IUseOverviewTab => {
  const [timeframe, setTimeframe] = useState<OverviewTimeframe>(DEFAULT_OVERVIEW_TIMEFRAME);

  const chartData =
    timeframe === 'Daily' ? DAILY_USAGE_DATA : timeframe === 'Yearly' ? YEARLY_USAGE_DATA : MONTHLY_USAGE_DATA;

  return {
    timeframe,
    setTimeframe,
    chartData,
    jobCreationData: JOB_CREATION_DATA,
  };
};
